import { useTheme } from "@mui/material";
import { useMeeting, useParticipant } from "@videosdk.live/react-sdk";
import React, { useEffect, useMemo, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { appThemes, useMeetingAppContext } from "../../MeetingAppContextDef";
import { meetingLayouts } from "../../MeetingAppContextDef";
import {
  calcQuality,
  getGridForMainParticipants,
  getGridRowsAndColumns,
  localAndPinnedOnTop,
  meetingResolutions,
} from "../../utils/common";
import useIsLGDesktop from "../../utils/useIsLGDesktop";
import useIsMobile from "../../utils/useIsMobile";
import useIsSMDesktop from "../../utils/useIsSMDesktop";
import useIsTab from "../../utils/useIsTab";
import useResponsiveSize from "../../utils/useResponsiveSize";
import { MemoizedMotionParticipant } from "../mainViewContainer/TestMainViewContainer";
import TestParticipantViewer from "../mainViewContainer/TestParticipantViewer";
import PresenterView from "../mainViewContainer/PresenterView";
import WhiteboardContainer, {
  convertHWAspectRatio,
} from "../../components/whiteboard/WhiteboardContainer";

const TestPinnedLayoutViewContainerCopy = ({
  height,
  width,
  whiteboardToolbarWidth,
  whiteboardSpacing,
}) => {
  const meetingLayout = meetingLayouts.GRID; // Default to GRID layout
  const sideBarMode = ""; // Default sideBarMode (replace with actual default value)
  const whiteboardStarted = false; // Default to false
  const animationsEnabled = true; // Default to true
  const reduceEdgeSpacing = false; // Default to false
  const isRecorder = false; // Default to false
  const layoutGridSize = 4; // Default grid size; replace with an appropriate default
  const appTheme = appThemes.LIGHT; // Default theme (LIGHT theme in this case)
  const meetingResolution = meetingResolutions.HD; // Default to HD resolution

  const mMeeting = useMeeting();
  console.log(mMeeting);
  const localParticipantId = mMeeting?.localParticipant?.id;
  const presenterId = mMeeting?.presenterId;
  const pinnedParticipants = mMeeting?.pinnedParticipants;

  useEffect(() => {
    console.log("Pinned Participants Updated:", pinnedParticipants);
  }, [pinnedParticipants]);

  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)" }}>
      {[...pinnedParticipants.keys()].map((participantId) => (
        <ParticipantView key={participantId} participantId={participantId} />
      ))}
    </div>
  );
};

const ParticipantView = ({ participantId }) => {
  const { displayName, micOn, webcamOn, webcamStream } = useParticipant(participantId);
  const webcamRef = useRef(null);

  useEffect(() => {
    if (webcamOn && webcamStream && webcamStream.track) {
      const mediaStream = new MediaStream();
      mediaStream.addTrack(webcamStream.track);
  
      if (webcamRef.current) {
        webcamRef.current.srcObject = mediaStream;
        webcamRef.current
          .play()
          .catch((error) => {
            console.error("Error starting video playback:", error);
            // Additional error handling, e.g., retrying or notifying the user
          });
      }
    } else {
      if (webcamRef.current) {
        webcamRef.current.srcObject = null;
      }
    }
  }, [webcamOn, webcamStream]);
  

  return (
    <div
      style={{
        height: "300px",
        width: "100%",
        background: "#C0C2C9",
        objectFit: "contain",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <p>{displayName}</p>
      <video
        width={"100%"}
        height={"100%"}
        ref={webcamRef}
        autoPlay
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      />
    </div>
  );
};


export default React.memo(
  TestPinnedLayoutViewContainerCopy,
  (prevProps, nextProps) =>
    prevProps.width === nextProps.width && prevProps.height === nextProps.height
);
